module.exports = "/_next/static/images/logo-aman-1-759d460cff574643b98360e015c7961f.png";